import React,{useState} from 'react';
import { Editor, EditorTools, EditorUtils } from "@progress/kendo-react-editor";


const {
    Bold,
    Italic,
    Underline,
    AlignLeft,
    AlignRight,
    AlignCenter,
    Indent,
    Outdent,
    OrderedList,
    UnorderedList,
    Undo,
    Redo,
    Link,
    Unlink,
}= EditorTools;

export const Customeditor = ({ value, onChange ,height,label}) => {
    const handleChange = (event) => {
      if (onChange) {
        onChange(event);
      }
    };
  
    return(
        <>
        <label>{label}</label>
        <Editor
                
                contentStyle={{ height: height }}
                onChange={handleChange}
                value={value}
                tools={[
                    [Bold, Italic, Underline],
                    [Undo, Redo],
                    [Link, Unlink],
                    [AlignLeft, AlignCenter, AlignRight],
                    [OrderedList, UnorderedList, Indent, Outdent],
                ]}

            />
            </>
    )
}

export default Customeditor